import React from 'react';
import { motion } from 'framer-motion';

const roles = ['Nitwebs', 'Code Rumble', 'Technocrats Horizons', 'Esferasoft'];

const ExperienceV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-gray-50 border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-8">Experience</h2>
        <div className="grid md:grid-cols-2 gap-5">
          {roles.map((role, i) => (
            <motion.div
              key={role}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              viewport={{ once: true }}
              className="rounded-xl bg-white p-6 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <h3 className="text-xl font-semibold text-gray-900">{role}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceV3;
